import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";


const TermModal = ({openModal,setOpenModal,actionLoading,handleActivateTerm,selectedTerm}) => {
  return (
    <Dialog open={openModal} onClose={() => setOpenModal(false)}>
      <DialogTitle>Confirm Action</DialogTitle>

      <DialogContent>
        <Typography sx={{ fontSize: "0.9rem" }}>
          Are you sure you want to{" "}
          <strong>{selectedTerm?.is_done ?   "activate":"deactivate"}</strong>{" "}
          <strong>{selectedTerm?.term}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenModal(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={handleActivateTerm}
          disabled={actionLoading}
        >
          {actionLoading ? (
            <CircularProgress size={16} />
          ) : selectedTerm?.is_done ? (
            "Yes  Activate"
          ):(
            "Yes, Deactivate"
          ) }
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TermModal
